import React, { useContext } from "react";
import { Grid, Typography } from "@material-ui/core";
import { UserDataContext } from "../Contexts/UserDataContext";
import InvoiceCard from "./InvoiceCard";
import FinanceCard from "./FinanceCard";
import DpcStatusCard from "./DpcStatusCard";
import { roles } from "../Mappings";

const Dashboard = () => {
  const { userData } = useContext(UserDataContext);

  console.log("dashboard render");

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Typography variant="h3">{userData.firstName}'s Dashboard</Typography>
      </Grid>

      <Grid item sm={6} xs={12}>
        <InvoiceCard />
      </Grid>

      {[roles.tollAdmin, roles.tollManager, roles.tollSystemAdmin].includes(
        userData.roleId
      ) && (
        <Grid item sm={6} xs={12}>
          <FinanceCard />
        </Grid>
      )}

      <Grid item xs={12}>
        <DpcStatusCard />
      </Grid>
    </Grid>
  );
};

export default Dashboard;
